export default __webpack_public_path__ + "static/media/upload.fd38c4a2.svg";